import { RESET_BIZ_BROWSER_STATE, UPDATE_BIZ_BROWSER_STATE } from '@/store/actions'
import { BizBrowserMode, IBizBrowserState } from '@/store/bizBrowser/interface'
import rfidDevicesConfig from '@/views/bizBrowser/config/rfidDevices.json'

const DEFAULT_DEVICE_KEY = 'tss_sr7'

export default {
  state: {
    mode: BizBrowserMode.IDLE,
    modeChangedAt: new Date(),
    selectedDeviceKey: DEFAULT_DEVICE_KEY,
    scannerSettings: rfidDevicesConfig[DEFAULT_DEVICE_KEY],
    isConnectedWithRfidDevice: false,
    isDeviceScanning: false,
    rfidPowerLevel: 20,
  },
  getters: {
    bizBrowserState: (state: IBizBrowserState) => state,
  },
  mutations: {
    [UPDATE_BIZ_BROWSER_STATE]: (state: IBizBrowserState, newState: Partial<IBizBrowserState>) => {
      Object.assign(state, newState, {
        modeChangedAt: new Date(),
      })
    },
    [RESET_BIZ_BROWSER_STATE]: (state: IBizBrowserState) => {
      state.mode = BizBrowserMode.IDLE
      state.modeChangedAt = new Date()
      state.durationSeconds = undefined
      state.selectedDeviceKey = DEFAULT_DEVICE_KEY
      state.scannerSettings = rfidDevicesConfig[DEFAULT_DEVICE_KEY]
      state.isConnectedWithRfidDevice = false
      state.isDeviceScanning = false
      state.rfidPowerLevel = 20
    },
  },
  actions: {
    [UPDATE_BIZ_BROWSER_STATE]: ({ commit }: { commit: Function }, newState: Partial<IBizBrowserState>) => {
      commit(UPDATE_BIZ_BROWSER_STATE, newState)
    },
    [RESET_BIZ_BROWSER_STATE]: ({ commit }: { commit: Function }) => {
      commit(RESET_BIZ_BROWSER_STATE)
    },
  },
}
